(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paradox-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-pdx-heroslider]').forEach(function(root){
    var track = root.querySelector('[data-pdx-track]');
    if(!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-pdx-slide]'));
    if(slides.length < 2) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pdx-dot]'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hold = 0; /* do tego czasu autoplay spi (user dotknal slidera) */
    var N = slides.length;

    /* Zawijanie BEZ cofki (Bartek 07.08): na koncu tasmy stoi KLON 1. slajdu.
       Ostatni -> "pierwszy" jedzie dalej w prawo na klona; potem cichy teleport
       (scroll bez animacji) na prawdziwy poczatek - ten sam obraz, oko nie
       widzi skoku. Klon nie ma kropki ani data-pdx-slide. */
    var clone = slides[0].cloneNode(true);
    clone.removeAttribute('data-pdx-slide');
    clone.setAttribute('aria-hidden', 'true');
    var cimg = clone.querySelector('img');
    if(cimg){ cimg.removeAttribute('fetchpriority'); cimg.setAttribute('loading', 'lazy'); cimg.alt = ''; }
    track.appendChild(clone);
    var all = slides.concat([clone]);

    function behave(){ return reduce.matches ? 'auto' : 'smooth'; }
    function centerLeft(el){ return el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2; }
    function scrollToEl(el, instant){
      track.scrollTo({ left: centerLeft(el), behavior: instant ? 'auto' : behave() });
    }
    function activeIndex(){ /* 0..N, gdzie N = klon */
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, dist = Infinity;
      all.forEach(function(s, i){
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
        if(d < dist){ dist = d; best = i; }
      });
      return best;
    }
    function paint(){
      var idx = activeIndex() % N; /* na klonie swieci kropka pierwszego */
      dots.forEach(function(d, i){ d.classList.toggle('is-active', i === idx); });
    }
    function goTo(i){
      i = ((i % N) + N) % N;
      if(activeIndex() >= N){
        /* stoimy na klonie: najpierw teleport na prawdziwy 1. (identyczny
           piksel w piksel), ruch docelowy dopiero w nastepnej klatce -
           inaczej smooth-scroll jechalby z pozycji klona w lewo */
        scrollToEl(slides[0], true);
        requestAnimationFrame(function(){ scrollToEl(slides[i]); });
      } else {
        scrollToEl(slides[i]);
      }
    }
    function forward(){
      var idx = activeIndex();
      if(idx >= N){ goTo(1); }
      else if(idx === N - 1){ scrollToEl(clone); } /* dalej w prawo, nie cofka */
      else { scrollToEl(slides[idx + 1]); }
    }
    function backward(){
      var idx = activeIndex();
      if(idx >= N){ scrollToEl(slides[N - 1]); } /* z klona krok w lewo */
      else { goTo(idx - 1); }
    }
    /* autoplay w prawo co 5 s (Bartek 06.08: 1,5 s bylo za szybko); stoi gdy
       karta w tle */
    setInterval(function(){
      if(document.hidden) return;
      if(Date.now() < hold) return;
      forward();
    }, 5000);
    ['pointerdown', 'touchstart', 'wheel'].forEach(function(ev){
      track.addEventListener(ev, function(){ hold = Date.now() + 4000; }, { passive: true });
    });
    dots.forEach(function(d, i){
      d.addEventListener('click', function(){ hold = Date.now() + 4000; goTo(i); });
    });
    var raf = 0;
    track.addEventListener('scroll', function(){
      if(raf) return;
      raf = requestAnimationFrame(function(){ raf = 0; paint(); });
    }, { passive: true });
    track.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft'){ e.preventDefault(); hold = Date.now() + 4000; backward(); }
      if(e.key === 'ArrowRight'){ e.preventDefault(); hold = Date.now() + 4000; forward(); }
    });
    paint();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
